export default "__VITE_ASSET__15e34ec7__"